import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupIcon from '@mui/icons-material/Group';
import PropTypes from 'prop-types';

const DisableGroupList = ({ groups, onDelete }) => {
    if (!groups || groups.length === 0) {
        return null;
    }

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px', mb: 2 }}>
                Selected Groups for Disable ({groups.length})
            </Typography>

            {groups.map((group, index) => (
                <Box
                    key={`disable-group-${index}`}
                    sx={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px',
                        padding: '16px 20px',
                        mb: 2,
                        backgroundColor: '#fafafa',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        '&:hover': {
                            backgroundColor: '#f5f5f5',
                        },
                    }}
                >
                    <Box sx={{ flex: 1 }}>
                        {/* AD Group Name */}
                        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px', mb: 1, color: '#000' }}>
                            {group.adGroup}
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                            {/* Owner Information */}
                            <Typography variant="body2" sx={{ color: '#666', fontSize: '14px' }}>
                                <strong>Owner:</strong> {group.adGroupOwner || 'N/A'}
                            </Typography>

                            {/* Members Count */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <GroupIcon sx={{ fontSize: '18px', color: '#1976d2' }} />
                                <Typography variant="body2" sx={{ color: '#666', fontSize: '14px' }}>
                                    <strong>Members:</strong> {group.members?.length || 0}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Action Buttons */}
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {/* View Members Button (Optional) */}
                        <IconButton
                            sx={{
                                display: 'none',
                                color: '#1976d2',
                                border: '1px solid #1976d2',
                                borderRadius: '4px',
                                width: '40px',
                                height: '40px',
                                '&:hover': {
                                    backgroundColor: '#e3f2fd',
                                },
                            }}
                            aria-label="view members"
                        >
                            <GroupIcon />
                        </IconButton>

                        {/* Delete Button */}
                        <IconButton
                            onClick={() => onDelete(index)}
                            sx={{
                                color: '#fff',
                                backgroundColor: '#d32f2f',
                                borderRadius: '4px',
                                width: '40px',
                                height: '40px',
                                '&:hover': {
                                    backgroundColor: '#b71c1c',
                                },
                            }}
                            aria-label="delete"
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

DisableGroupList.propTypes = {
    groups: PropTypes.arrayOf(
        PropTypes.shape({
            adGroup: PropTypes.string,
            adGroupOwner: PropTypes.string,
            members: PropTypes.arrayOf(PropTypes.object),
        })
    ),
    onDelete: PropTypes.func.isRequired,
};

DisableGroupList.defaultProps = {
    groups: [],
};

export default DisableGroupList;
